import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { DateFormatter, formatDatetime } from '@flipster/utils/datetime';

import { sparkAuctionBunja } from '../_bunja';

export const AuctionTitle = () => {
  const { prizeRevealMessageAtom } = useBunja(sparkAuctionBunja);
  const prizeRevealMessage = useAtomValue(prizeRevealMessageAtom);
  return (
    <>
      Bid using your Sparks. <br />
      {prizeRevealMessage}
    </>
  );
};

export const AuctionDetails = () => {
  const { auctionDatesAtom } = useBunja(sparkAuctionBunja);
  const { end, rewardReveal } = useAtomValue(auctionDatesAtom);

  const auctionEnds = formatDatetime(end, { format: DateFormatter.ShortYearDateTime, isUTC: true });
  const prizeReveal = formatDatetime(rewardReveal, { format: DateFormatter.ShortYearDateTime, isUTC: true });

  return (
    <div className={css({ w: { tablet: '50%' } })}>
      <h2 className={css({ textStyle: 'Title/S', mb: 8 })}>
        <FormattedMessage id='Autogen_common.r251126.s_Auction_details' />
      </h2>
      <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2' })}>
        <FormattedMessage
          id='Autogen_common.r251126.s_Start_Bidding_Message'
          values={{ word0: `${auctionEnds} UTC`, word1: `${prizeReveal} UTC` }}
        />
      </p>
    </div>
  );
};
